import React, { useEffect } from "react";
import PdpPriceSticky from "../../react-components/pdp-sticky-price";
import ModelViewer from "../../react-components/3d-viewer";
import PropTypes from "prop-types";
import PdpOptionList from "../../react-components/pdp-option-list";
import "./style.scss";

const PdpPage = React.forwardRef((props, ref) => {
  const { fields, price, canvas, scene, onSelectCallback, optionList, sceneData, onRefLoaded = () => {}, isFetchingNewData, showFootnote, loanBannerHeight, currentPlan } = props;
  let buttonEvents = {};

  buttonEvents["engine-phev"] = () => scene.callbacks.setPHEV(canvas, true);
  buttonEvents["engine-hev"] = () => scene.callbacks.setPHEV(canvas, false);
  buttonEvents["yes-towbar"] = () => scene.callbacks.setTowbar(canvas, true);
  buttonEvents["no-towbar"] = () => scene.callbacks.setTowbar(canvas, false);
  buttonEvents["winter-tyres"] = () => scene.callbacks.displaySnow(canvas, true);
  buttonEvents["frictionless-winterwheels"] = () => scene.callbacks.displaySnow(canvas, true);
  buttonEvents["studded-winterwheels"] = () => scene.callbacks.displaySnow(canvas, true);
  buttonEvents["no-winter-tyres"] = () => scene.callbacks.displaySnow(canvas, false);

  useEffect(() => {
    onRefLoaded();
  }, [ref]);

  useEffect(() => {
    handleEmptyDivLoanBanner();
  }, [loanBannerHeight]);

  const handleEmptyDivLoanBanner = () => {
    const emptyDiv = document.getElementsByClassName("sticky-banner-empty-div")[0];
    if (loanBannerHeight) {
      if (window.innerWidth > 992) {
        emptyDiv.style.height = "10vh";
      }
      if (window.innerWidth < 767) {
        emptyDiv.style.height = "8vh";
      }
      if (window.innerWidth < 376) {
        emptyDiv.style.height = "4vh";
      }
    }
  };

  return (
    <div className="pdp-page">
      <ModelViewer fields={fields} canvas={canvas} scene={scene} data={sceneData} loanBannerHeight={loanBannerHeight}>
        <PdpPriceSticky {...{ ...price, showFootnote, currentPlan }} />
        <div ref={ref} className="sticky-banner-empty-div"></div>
        <div className="viewer-bottom-gradient" />
      </ModelViewer>
      <PdpOptionList {...optionList} onSelectCallback={onSelectCallback} buttonEvents={buttonEvents} scrollOffset={() => canvas.height} canvas={canvas} scene={scene} isFetchingNewData={isFetchingNewData} />
    </div>
  );
});
PdpPage.displayName = "PdpPage";
PdpPage.propTypes = {
  price: PropTypes.object,
  optionList: PropTypes.object
};

export default PdpPage;
